import qs from 'qs';
import instance, { PPR_API_URL } from 'api';
import { AxiosRequestConfig } from 'axios';
import { IExecutor } from './interfaces';

export const loadMatrixPprEto = (areaId: number, userIds?: string[], positionIds?: number[]) => {
  return instance(true, PPR_API_URL)
    .get('/matrix/executor/load/' + areaId, {
      params: { userIds, positionIds },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
    .then((response) => response.data);
};

export const addAreaExecutorPprEto = (areaId: number, userId: string, positionId: number) => {
  return instance(true, PPR_API_URL)
    .post<IExecutor>(`/matrix/executor/addArea`, { areaId, userId, positionId })
    .then((response) => response.data);
};

export const deleteAreaExecutorPprEto = (areaId: number, userId: string, positionId: number) => {
  return instance(true, PPR_API_URL)
    .post<IExecutor>(`/matrix/executor/deleteArea`, { areaId, userId, positionId })
    .then((response) => response.data);
};

export const addRealEstateExecutorPprEto = (
  areaId: number,
  userId: string,
  positionId: number,
  realEstateId: string,
) => {
  return instance(true, PPR_API_URL)
    .post<IExecutor>(`/matrix/executor/addRealEstate`, { areaId, userId, positionId, realEstateId })
    .then((response) => response.data);
};

export const deleteRealEstateExecutorPprEto = (
  areaId: number,
  userId: string,
  positionId: number,
  realEstateId: string,
) => {
  return instance(true, PPR_API_URL)
    .post('/matrix/executor/deleteRealEstate', { areaId, userId, positionId, realEstateId })
    .then((response) => response.data);
};

export const reassignExecutorPprEto = (
  areaId: number,
  data: {
    oldUserId: string;
    oldPositionId: number;
    newUserId: string;
    newPositionId: number;
  },
) => {
  return instance(true, PPR_API_URL)
    .post<IExecutor>('/matrix/executor/replaceExecutor/' + areaId, data)
    .then((response) => response.data);
};

export const getAreaExecutorsPprEto = (areaId: number) => {
  return instance(true, PPR_API_URL)
    .get<IExecutor[]>('/matrix/findExecutor/' + areaId)
    .then((response) => response.data);
};

export const getUsers = (search: string | null, config: AxiosRequestConfig = {}) => {
  return instance()
    .post('/users/list', search ? { search } : {}, config)
    .then((response) => response.data);
};

export const getPositions = () => {
  return instance()
    .post('/dictionary/adminPositions/listExecutors', {})
    .then((response) => response.data);
};
